<div class="row">
    <div class="col">
      <div *ngFor="let alert of alerts">
        <ngb-alert [type]="alert.type" (closed)="close(alert)">{{ alert.message }}</ngb-alert>
      </div>
    </div>
  </div>